module.exports = __webpack_public_path__ + "img/majid-mirza.858fec8b.png";